import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, {type SelectChangeEvent} from '@mui/material/Select';
import type {SxProps} from '@mui/material';

type Props = {
    label : string;
    id : string;
    values : string[];
    onChange : (value: string) => void;
    boxSx ?: SxProps;
};

const SelectDepartmentFilter = ({label, id, values, onChange, boxSx} : Props) => {
    const [value, setValue] = React.useState('');

    const handleChange = (event: SelectChangeEvent) => {
        setValue(event.target.value as string);
        onChange(event.target.value as string);
    };

    return (
        <Box sx={{minWidth: 120, ...boxSx}}>
            <FormControl fullWidth>
                <InputLabel id={`${id}-select-label`}>{label}</InputLabel>
                <Select
                    labelId={`${id}-select-label`}
                    id={`${id}-select`}
                    value={value}
                    label={label}
                    onChange={handleChange}
                >
                    <MenuItem
                        key={`${id}-select-all`}
                        value=''
                    >
                        All
                    </MenuItem>
                    {values.map((value) => <MenuItem
                        key={`${id}-select-${value}`}
                        value={value}
                    >
                        {value}
                    </MenuItem>)}
                </Select>
            </FormControl>
        </Box>
    );
}

export default SelectDepartmentFilter;
